import { capitalGlobalQuotesService } from '@/services/quotes/capital-global';
import type { AttachQuotePayload } from '@/services/quotes/types';
import { ValidationError } from '@/shared/exceptions/validation.error';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useUpdateCapitalGlobalQuote() {
  const queryClient = useQueryClient();

  return useMutation<
    { success: boolean; data?: unknown; error?: string; message?: string },
    Error | ValidationError,
    { id: string; payload: Partial<AttachQuotePayload> }
  >({
    mutationKey: ['quotes', 'update', 'capital-global'],
    mutationFn: async ({ id, payload }) => {
      const stepCode = payload.step?.trim();
      const enrichedPayload: Partial<AttachQuotePayload> = stepCode
        ? { ...payload, validationEventCode: stepCode }
        : payload;
      const response = await capitalGlobalQuotesService.updateQuote(
        id,
        enrichedPayload
      );
      if (!response.success) throw new Error(response.error || 'Erro');
      return response;
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['proposal-details', variables.id],
      });
    },
    onError: (_error, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['proposal-details', variables.id],
      });
      queryClient.invalidateQueries({ queryKey: ['quotes'] });
    },
  });
}
